import React, {Component} from 'react'
import {Alert, Col, Form, Modal, Radio, Row} from 'antd';
import {getCards, setCardBooking} from '../../../actions/paymentActions'
import {changeCardBooking} from '../../../actions/bookActions'
import {connect} from 'react-redux';
import ProtoType from 'prop-types'
import SplitFormStripe from "../../Settings/Dashboard/Include/SplitFormStripe";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);


const confirm = Modal.confirm;

class UpdateCard extends Component {

  constructor(props) {
    super(props)
    this.state = {
      user: {},
      loading: false,
      error: [],
      setCardDefault: true,
      disableSubmit: true,
      cardBooking: props.cardBooking
    }
  }

  showConfirm = (card_id) => {

    confirm({
      title: 'Do you want to change card for this booking?',
      content: '',
      onOk: () => {
        changeCardBooking(this.props.booking._id, card_id).then(res => {
          this.setState({
            cardBooking: this.props.cards.find(card => card._id == card_id)
          })
        }).catch(err => {

        })

      },
      onCancel() {
      },
    });
  }

  onChangeCardBooking = (e) => {
    let card_id = e.target.value || ''
    if (card_id != '') {
      this.showConfirm(card_id);
    }
  }

  render() {
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    }
    return (

      <Row>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>

          {this.props.cards.length == 0 && (<Alert message="You have not added any cards yet. " type="info"/>)}

          {this.props.cards.length > 0 && (

            <div>
              <Radio.Group onChange={this.onChangeCardBooking} value={this.state.cardBooking._id}>
                {this.props.cards.map(card => {
                  return (<Radio key={card._id} style={radioStyle} value={card._id}>
                    {/************* {card.lastFourDigits} - ({ card.cardType}) */}
                    <span className="brand" style={{marginRight: 10, fontWeight: 600}}>{card.cardType}</span>
                    <span className="number"><span>**** **** ****</span> {card.lastFourDigits} __ <span style={{fontWeight: 600}}>{card.brainTreeCardToken ? 'Braintree' : 'Stripe'}</span></span>
                  </Radio>)
                })}
              </Radio.Group>
            </div>

          )}
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Elements stripe={stripePromise} options={{locale: 'en'}}>
            <SplitFormStripe getCards={this.props.getCards}/>
          </Elements>
        </Col>
      </Row>


    )
  }
}


UpdateCard.protoType = {
  cards: ProtoType.array.isRequired,
  cardBooking: ProtoType.object.isRequired,
  booking: ProtoType.object.isRequired,
}


const mapStateToProps = (state) => {
  return {}
}
const WrappedUpdateCard = Form.create()(UpdateCard);
export default connect(mapStateToProps, {setCardBooking, getCards})(WrappedUpdateCard)



// WEBPACK FOOTER //
// ./src/components/Projects/Include/UpdateCard.js